import { Components } from '../../../styles';
import { ELEVATION } from './commons';
import { token, tokenToPx } from './getToken';

export const tooltipTheme = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        ...ELEVATION.level2,
        margin: 8,
        fontSize: tokenToPx('bodySmallFontSize'),
        fontWeight: token('bodySmallFontWeight'),
        lineHeight: tokenToPx('bodySmallLineHeight'),
        letterSpacing: tokenToPx('bodySmallLetterSpacing'),
        color: token('colorInverseOnSurface'),
        backgroundColor: token('colorInverseSurface'),
        '&.variant-light': {
          color: token('colorOnSurface'),
          backgroundColor: token('colorSurfaceVariant'),

          '& .MuiTooltip-arrow': {
            color: token('colorSurfaceVariant')
          }
        },
        '*:not(.MuiTooltip-arrow)': {
          textDecoration: 'unset !important',
          color: 'unset !important',
          backgroundColor: 'unset !important',
          padding: 'unset !important',
          margin: 'unset !important'
        }
      },
      arrow: {
        color: token('colorInverseSurface')
      }
    }
  }
} satisfies Components;
